import React from 'react';
export function MikronDNASection() {
  return <section className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2434">
      <div className="bg-[#1874cd] py-6 px-6" data-id="element-2435">
        <h2 className="text-3xl font-bold text-white text-center" data-id="element-2436">
          Mikron DNA
        </h2>
      </div>
      <div className="overflow-x-auto" data-id="element-2437">
        <table className="w-full text-left border-collapse" data-id="element-2438">
          <thead data-id="element-2439">
            <tr className="bg-gray-50 border-b border-gray-200" data-id="element-2440">
              <th className="py-4 px-6 font-bold text-navy text-lg text-center w-1/3" data-id="element-2441">
                DNA
              </th>
              <th className="py-4 px-6 font-bold text-navy text-lg text-center w-2/3" data-id="element-2442">
                User Benefit
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 text-gray-700 text-center" data-id="element-2443">
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2444">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2445">
                Integrated Chuck
              </td>
              <td className="py-4 px-6" data-id="element-2446">
                Improved Accuracy - Less Stack Error - Reach your tolerances
                faster
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2447">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2448">
                Direct Rotary Torque Table
              </td>
              <td className="py-4 px-6" data-id="element-2449">
                Ultra Dynamic, High Precision, Less Wear - Ensures repeatable
                accuracy for the life of the machine - Made in GF Machining
                Solutions factory since 2001
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2450">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2451">
                Step-Tec Spindle
              </td>
              <td className="py-4 px-6" data-id="element-2452">
                High-RPM, High Power to size ratio, Designed to run full power
                around the clock, Dependable - Long service life, extreme
                precision
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2453">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2454">
                Integrated Pallet Changer System
              </td>
              <td className="py-4 px-6" data-id="element-2455">
                Unattended Machine Uptime - Industry leading affordability, FAST
                ROI
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2456">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2457">Heidenhain CNC</td>
              <td className="py-4 px-6" data-id="element-2458">
                Fully Loaded - Best in Class for High Speed 5-axis Machining -
                Take advantage of Mikron Smart Machining Modules
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2459">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2460">
                Polymergranite Construction
              </td>
              <td className="py-4 px-6" data-id="element-2461">
                Thermostability, Vibration Dampening, Heavy - Same Material Used
                On CMM - Handles high acceleration - Better surface finish -
                better accuracy control
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2462">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2463">
                High Acceleration
              </td>
              <td className="py-4 px-6" data-id="element-2464">
                Key to Fast Cycle Times & Long Tool Life - reduce heat build up
                in tool and workpiece material
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2465">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2466">
                Symmetrical Design
              </td>
              <td className="py-4 px-6" data-id="element-2467">
                High Accuracy, Ergonomics, Stability throughout the day
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-2468">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-2469">
                Automation in Mind
              </td>
              <td className="py-4 px-6" data-id="element-2470">
                Designed to be Modular & Scalable - Ergonomic - No operator
                obstruction
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}